import { useCallback, useEffect, useState } from 'react';

const read = (key) => {
    try {
        return localStorage.getItem(key) === '1';
    } catch {
        return false;
    }
};

/**
 * Sidebar réduite (icônes seules) sur grand écran, mémorisée d'une page à l'autre.
 * Sur mobile la sidebar reste un tiroir complet : seul `isOpen` compte.
 */
const useSidebarCollapsed = (storageKey) => {
    const [collapsed, setCollapsed] = useState(() => read(storageKey));

    useEffect(() => {
        try {
            localStorage.setItem(storageKey, collapsed ? '1' : '0');
        } catch {
            // stockage indisponible : l'état reste en mémoire
        }
    }, [storageKey, collapsed]);

    const toggleCollapsed = useCallback(() => setCollapsed((c) => !c), []);

    return [collapsed, toggleCollapsed];
};

export default useSidebarCollapsed;
